import { render, staticRenderFns } from "./InventoryPhysicalR.vue?vue&type=template&id=b35f8b20&scoped=true"
import script from "./InventoryPhysicalR.vue?vue&type=script&lang=js"
export * from "./InventoryPhysicalR.vue?vue&type=script&lang=js"
import style0 from "./InventoryPhysicalR.vue?vue&type=style&index=0&id=b35f8b20&prod&scoped=true&lang=css"
import style1 from "./InventoryPhysicalR.vue?vue&type=style&index=1&id=b35f8b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35f8b20",
  null
  
)

export default component.exports